import { isZebraScanner } from "@deliverr/ui-facility";
import { MenuPageConfig } from "@deliverr/ui-facility/lib-facility/components/Menu/MenuConfig";
import { hubSortationCenters } from "@deliverr/ui-facility/lib-facility/hubs";
import { AUTOMATED_SORTATION_CENTERS } from "sortation/pages/DivertLaneScan/automatedSortationCenters";
import { SHIP_TO_STORE_SORTATION_CENTERS } from "sortation/pages/ShipToStoreLabelScan/shipToStoreSortationCenters";
import { STAGING_SCAN_SORTATION_CENTERS } from "sortation/pages/StagingScan/stagingScanSortationCenters";
import { TRANSFER_SCAN_SORTATION_CENTERS } from "sortation/pages/TransferScan/transferScanSortationCenters";
import { SortationPath } from "./sortationPath";

export const sortationMenuConfig: Record<string, MenuPageConfig> = {
  MAIN: {
    items: [
      {
        icon: "scan",
        text: "Arrival Scan",
        path: SortationPath.ARRIVAL,
      },
      {
        icon: "scan",
        text: "Customs Scan",
        path: SortationPath.CUSTOMS,
      },
      {
        icon: "dolly",
        text: "Gaylord Scan",
        path: SortationPath.OUTBOUND,
      },
      {
        icon: "dolly",
        text: "Divert Lane Scan",
        path: SortationPath.DIVERT_LANE,
        isHidden: (sortationId) => !(sortationId && AUTOMATED_SORTATION_CENTERS.includes(sortationId)),
      },
      {
        icon: "scan",
        text: "Ship To Store Label Scan",
        path: SortationPath.SHIP_TO_STORE_LABEL_SCAN,
        isHidden: (sortationId) => !(sortationId && SHIP_TO_STORE_SORTATION_CENTERS.includes(sortationId)),
      },
      {
        icon: "code-branch",
        text: "Hub App",
        isHidden: (sortationId) => !(sortationId && hubSortationCenters.includes(sortationId)),
        path: SortationPath.HUB_APP_REDIRECT,
      },
      {
        icon: "dolly",
        text: "Dock doors",
        path: SortationPath.DOCK_DOOR_SCAN_V2,
      },
      {
        icon: "dolly",
        text: "Left In Building",
        path: SortationPath.LEFT_IN_BUILDING_SCAN,
      },
      {
        icon: "dolly",
        text: "BOL/Trailer Scan",
        path: SortationPath.LOAD_TO_TRAILER_SCAN,
      },
      {
        icon: "dolly",
        text: "Trailer Closeout Scan",
        path: SortationPath.TRAILER_CLOSEOUT_SCAN,
      },
      {
        icon: "dolly",
        text: "Transfer Scan",
        path: SortationPath.TRANSFER_SCAN,
        isHidden: (sortationId) => !(sortationId && TRANSFER_SCAN_SORTATION_CENTERS.includes(sortationId)),
      },
      {
        icon: "dolly",
        text: "Staging Scan",
        path: SortationPath.STAGING_SCAN,
        isHidden: (sortationId) => !(sortationId && STAGING_SCAN_SORTATION_CENTERS.includes(sortationId)),
      },
      {
        icon: "dolly",
        text: "Zone Skip Arrival Scan",
        path: SortationPath.ZONE_SKIP_ARRIVAL_SCAN,
      },
      {
        icon: "print",
        text: "Print labels",
        path: SortationPath.LABEL_PRINT,
      },
      {
        icon: "scan",
        text: "Utility scans",
        path: SortationPath.UTILITY_SCAN,
      },
      {
        icon: "document",
        text: "Manifests",
        path: SortationPath.MANIFESTS,
        isHidden: isZebraScanner,
      },
    ],
  },
};
